import React from "react";

const BlogSocial = () => {
  return (
    <>
      <div className="w-full bg-green- my-5 md:my-10">
        <div className="flex flex-row justify-evenly">

            {/* 1 */}
            <div className="flex flex-row items-center bg-blue-600 p-1 md:p-3 rounded-full cursor-pointer">
                {/* logo */}
                <i class="text-xs-s md:text-xs fab fa-facebook-f px-1 text-white"></i>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    |
                </div>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    Facebook
                </div>
            </div>


            {/* 2 */}
            <div className="flex flex-row items-center bg-blue-500 p-1 md:p-3 rounded-full cursor-pointer">
                {/* logo */}
                <i class="text-xs-s md:text-xs fab fa-twitter px-1 text-white"></i>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    |
                </div>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    Twitter
                </div>
            </div>


            {/* 3 */}
            <div className="flex flex-row items-center bg-red-600 p-1 md:p-3 rounded-full cursor-pointer">
                {/* logo */}
                <i class="text-xs-s md:text-xs fab fa-pinterest-p px-1 text-white"></i>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    |
                </div>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    Pinterest
                </div>
            </div>

            {/* 4 */}
            <div className="flex flex-row items-center bg-green-600 p-1 md:p-3 rounded-full cursor-pointer">
                {/* logo */}
                <i class="text-xs-s md:text-xs fab fa-whatsapp px-1 text-white"></i>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    |
                </div>
                {/* text */}
                <div className="text-xs-s md:text-xs px-1 text-white">
                    Whatsapp
                </div>
            </div>




        </div>
      </div>
    </>
  );
};

export default BlogSocial;
